<div [ngClass]="{ 'dark text-white-dark': store.semidark }">
    <nav class="sidebar fixed bottom-0 top-0 z-50 h-full min-h-screen w-[260px] shadow-[5px_0_25px_0_rgba(94,92,154,0.1)] transition-all duration-300">
        <div class="h-full bg-white dark:bg-[#0e1726]">
            <div class="flex items-center justify-between px-4 py-3">
                <a routerLink="/" class="main-logo flex shrink-0 items-center">
                    <img class="ml-[5px] w-32 flex-none" [src]="logoPath" alt="" />
                </a>
                <a
                    href="javascript:;"
                    class="collapse-icon flex h-8 w-8 items-center rounded-full transition duration-300 hover:bg-gray-500/10 hover:text-primary rtl:rotate-180 dark:text-white-light dark:hover:bg-dark-light/10"
                    (click)="storeData.dispatch({ type: 'toggleSidebar'})"
                >
                    <icon-carets-down class="m-auto rotate-90" />
                </a>
            </div>
            <ng-scrollbar class="relative !h-[calc(100vh-80px)]" appearance="compact">
                <ul class="relative space-y-0.5 p-4 py-0 font-semibold">

                    <li class="nav-item">
                        <ul>
                            <li class="nav-item">
                                <a routerLink="/home" class="group" routerLinkActive="active" (click)="toggleMobileMenu()">
                                    <div class="flex items-center">
                                        <icon-home class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                        >{{ 'home' | translate }}</span
                                        >
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </li>

                    <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">
                        <icon-minus class="hidden h-5 w-4 flex-none" />
                        <span>{{ ('process_monitoring' | translate) || '&nbsp;' }}</span>
                    </h2>

                    <li class="nav-item">
                        <ul>
                            @if (featureFlags.pmc.visible) {

                                <li class="nav-item">
                                    <ul>

                                        <li class="nav-item">
                                            <a routerLink="/pmc/list"
                                               class="group"
                                               routerLinkActive="active"
                                               [attr.aria-disabled]="!featureFlags.pmc.enabled"
                                               [attr.tabindex]="featureFlags.pmc.enabled ? null : -1"
                                               [ngClass]="{ active: activeDropdown.includes('pmc') }"
                                               (click)="toggleMobileMenu()">
                                                <div class="flex items-center">
                                                    <icon-checks class="shrink-0 group-hover:!text-primary" />
                                                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                                    >{{ 'process_monitoring_checks' | translate }}</span
                                                    >
                                                </div>
                                            </a>
                                        </li>

                                        <li class="nav-item">
                                            <a routerLink="/pmc/calendar"
                                               class="group"
                                               routerLinkActive="active"
                                               [attr.aria-disabled]="!featureFlags.pmc.enabled"
                                               [attr.tabindex]="featureFlags.pmc.enabled ? null : -1"
                                               [ngClass]="{ active: activeDropdown.includes('pmc_calendar') }"
                                               (click)="toggleMobileMenu()">
                                                <div class="flex items-center">
                                                    <icon-calendar class="shrink-0 group-hover:!text-primary" />
                                                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                                    >{{ 'process_monitoring_checks_calendar' | translate }}</span
                                                    >
                                                </div>
                                            </a>
                                        </li>

                                        <li class="nav-item">
                                            <a routerLink="/pmc/spc"
                                               class="group"
                                               routerLinkActive="active"
                                               [attr.aria-disabled]="!featureFlags.pmc.enabled"
                                               [attr.tabindex]="featureFlags.pmc.enabled ? null : -1"
                                               [ngClass]="{ active: activeDropdown.includes('spc') }"
                                               (click)="toggleMobileMenu()">
                                                <div class="flex items-center">
                                                    <icon-chart-square class="shrink-0 group-hover:!text-primary" />
                                                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                                    >{{ 'SPC' | translate }}</span
                                                    >
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </li>
                            }
                        </ul>
                    </li>

                    <li class="nav-item">
                        <ul>
                            @if (featureFlags.qualification.visible) {

                                <li class="nav-item">
                                    <ul>
                                        <li class="nav-item">
                                            <a routerLink="/qualification/matrix"
                                               class="group"
                                               routerLinkActive="active"
                                               [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                               [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                               [ngClass]="{ active: activeDropdown.includes('qualification') }"
                                               (click)="toggleMobileMenu()">
                                                <div class="flex items-center">
                                                    <icon-award class="shrink-0 group-hover:!text-primary" />
                                                    <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                                    >{{ 'qualification_matrix' | translate }}</span
                                                    >
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </li>

                                <!--
                                <li class="accordion menu nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.qualification.enabled }">
                                    <button
                                        type="button"
                                        class="nav-link group w-full"
                                        [disabled]="!featureFlags.qualification.enabled"
                                        [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                        [ngClass]="{ active: activeDropdown.includes('qualification') }"
                                        (click)="toggleAccordion('qualification')"
                                    >
                                        <div class="flex items-center">
                                            <icon-award class="shrink-0 group-hover:!text-primary" />
                                            <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                            >{{ 'certification_qualification' | translate }}</span
                                            >
                                        </div>
                                        <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('qualification') }">
                                            <icon-caret-down />
                                        </div>
                                    </button>
                                    <div [@slideDownUp]="!activeDropdown.includes('qualification')" class="accordion-content">
                                        <ul class="sub-menu text-gray-500">

                                            <li>
                                                <a
                                                    routerLink="/qualification/personnel-list"
                                                    routerLinkActive="active"
                                                    [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                                    [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                                    (click)="toggleMobileMenu()"
                                                >{{ 'personnel_list' | translate }}</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    routerLink="/qualification/experience/list"
                                                    routerLinkActive="active"
                                                    [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                                    [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                                    (click)="toggleMobileMenu()"
                                                >{{ 'experience_history' | translate }}</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    routerLink="/qualification/training/list"
                                                    routerLinkActive="active"
                                                    [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                                    [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                                    (click)="toggleMobileMenu()"
                                                >{{ 'formal_training' | translate }}</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    routerLink="/qualification/examination"
                                                    routerLinkActive="active"
                                                    [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                                    [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                                    (click)="toggleMobileMenu()"
                                                >{{ 'examination' | translate }}</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    routerLink="/qualification/visual-acuity"
                                                    routerLinkActive="active"
                                                    [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                                    [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                                    (click)="toggleMobileMenu()"
                                                >{{ 'visual_acuity' | translate }}</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    routerLink="/qualification/certification"
                                                    routerLinkActive="active"
                                                    [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                                    [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                                    (click)="toggleMobileMenu()"
                                                >{{ 'certification' | translate }}</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    routerLink="/qualification/performance-review"
                                                    routerLinkActive="active"
                                                    [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                                    [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                                    (click)="toggleMobileMenu()"
                                                >{{ 'performance_review' | translate }}</a
                                                >
                                            </li>
                                            <li>
                                                <a
                                                    routerLink="/qualification/defect-rate-monitoring"
                                                    routerLinkActive="active"
                                                    [attr.aria-disabled]="!featureFlags.qualification.enabled"
                                                    [attr.tabindex]="featureFlags.qualification.enabled ? null : -1"
                                                    (click)="toggleMobileMenu()"
                                                >{{ 'defect_rate_monitoring' | translate }}</a
                                                >
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                -->
                            }
                            @if (featureFlags.audit.visible) {
                            <li class="accordion menu nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.audit.enabled }">
                                <button
                                    type="button"
                                    class="nav-link group w-full"
                                    [disabled]="!featureFlags.audit.enabled"
                                    [attr.aria-disabled]="!featureFlags.audit.enabled"
                                    [ngClass]="{ active: activeDropdown.includes('audit') }"
                                    (click)="toggleAccordion('audit')"
                                >
                                    <div class="flex items-center">
                                        <icon-list-check class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                            >{{ 'audit' | translate }}</span
                                        >
                                    </div>
                                    <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('audit') }">
                                        <icon-caret-down />
                                    </div>
                                </button>
                                <div [@slideDownUp]="!activeDropdown.includes('audit')" class="accordion-content">
                                    <ul class="sub-menu text-gray-500">
                                        <li>
                                            <a
                                                routerLink="/audit/list"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.audit.enabled"
                                                [attr.tabindex]="featureFlags.audit.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >{{ 'audit' | translate }}</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                routerLink="/audit/calendar"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.audit.enabled"
                                                [attr.tabindex]="featureFlags.audit.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >{{ 'audit_calendar' | translate }}</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            }
                            @if (featureFlags.stampControl.visible) {
                            <li class="nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.stampControl.enabled }">
                                <a
                                    routerLink="/stampcontrol/list"
                                    class="group"
                                    routerLinkActive="active"
                                    [attr.aria-disabled]="!featureFlags.stampControl.enabled"
                                    [attr.tabindex]="featureFlags.stampControl.enabled ? null : -1"
                                    (click)="toggleMobileMenu()"
                                >
                                    <div class="flex items-center">
                                        <icon-clipboard-text class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                            >{{ 'stampcontrol' | translate }}</span
                                        >
                                    </div>
                                </a>
                            </li>
                            }
                            @if (featureFlags.inspectionLog.visible) {
                            <li class="nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.inspectionLog.enabled }">
                                <a
                                    routerLink="/inspectionlog/list"
                                    class="group"
                                    routerLinkActive="active"
                                    [attr.aria-disabled]="!featureFlags.inspectionLog.enabled"
                                    [attr.tabindex]="featureFlags.inspectionLog.enabled ? null : -1"
                                    (click)="toggleMobileMenu()"
                                >
                                    <div class="flex items-center">
                                        <icon-eye class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                            >{{ 'inspectionlog' | translate }}</span
                                        >
                                    </div>
                                </a>
                            </li>
                            }
                            @if (featureFlags.calibration.visible) {
                            <li class="accordion menu nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.calibration.enabled }">
                                <button
                                    type="button"
                                    class="nav-link group w-full"
                                    [disabled]="!featureFlags.calibration.enabled"
                                    [attr.aria-disabled]="!featureFlags.calibration.enabled"
                                    [ngClass]="{ active: activeDropdown.includes('calibration') }"
                                    (click)="toggleAccordion('calibration')"
                                >
                                    <div class="flex items-center">
                                        <icon-settings class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                            >{{ 'calibration' | translate }}</span
                                        >
                                    </div>
                                    <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('calibration') }">
                                        <icon-caret-down />
                                    </div>
                                </button>
                                <div [@slideDownUp]="!activeDropdown.includes('calibration')" class="accordion-content">
                                    <ul class="sub-menu text-gray-500">
                                        <li>
                                            <a
                                                routerLink="/calibration/list"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.calibration.enabled"
                                                [attr.tabindex]="featureFlags.calibration.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >{{ 'calibration' | translate }}</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                routerLink="/calibration/calendar"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.calibration.enabled"
                                                [attr.tabindex]="featureFlags.calibration.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >{{ 'calibration_calendar' | translate }}</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            }
                            @if (featureFlags.maintenance.visible) {
                            <li class="accordion menu nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.maintenance.enabled }">
                                <button
                                    type="button"
                                    class="nav-link group w-full"
                                    [disabled]="!featureFlags.maintenance.enabled"
                                    [attr.aria-disabled]="!featureFlags.maintenance.enabled"
                                    [ngClass]="{ active: activeDropdown.includes('maintenance') }"
                                    (click)="toggleAccordion('maintenance')"
                                >
                                    <div class="flex items-center">
                                        <icon-refresh class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                            >{{ 'maintenance' | translate }}</span
                                        >
                                    </div>
                                    <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('maintenance') }">
                                        <icon-caret-down />
                                    </div>
                                </button>
                                <div [@slideDownUp]="!activeDropdown.includes('maintenance')" class="accordion-content">
                                    <ul class="sub-menu text-gray-500">
                                        <li>
                                            <a
                                                routerLink="/maintenance/list"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.maintenance.enabled"
                                                [attr.tabindex]="featureFlags.maintenance.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >{{ 'preventive_maintenance' | translate }}</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                routerLink="/maintenance/calendar"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.maintenance.enabled"
                                                [attr.tabindex]="featureFlags.maintenance.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >{{ 'maintenance_calendar' | translate }}</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            }
<!--
                            @if (featureFlags.pmc.visible) {
                            <li class="accordion menu nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.pmc.enabled }">
                                <button
                                    type="button"
                                    class="nav-link group w-full"
                                    [disabled]="!featureFlags.pmc.enabled"
                                    [attr.aria-disabled]="!featureFlags.pmc.enabled"
                                    [ngClass]="{ active: activeDropdown.includes('process_monitoring_checks') }"
                                    (click)="toggleAccordion('process_monitoring_checks')"
                                >
                                    <div class="flex items-center">
                                        <icon-chart-square class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                            >{{ 'process_monitoring' | translate }}</span
                                        >
                                    </div>
                                    <div [ngClass]="{ 'rtl:rotate-90 -rotate-90': !activeDropdown.includes('process_monitoring_checks') }">
                                        <icon-caret-down />
                                    </div>
                                </button>
                                <div [@slideDownUp]="!activeDropdown.includes('process_monitoring_checks')" class="accordion-content">
                                    <ul class="sub-menu text-gray-500">
                                        <li>
                                            <a
                                                routerLink="/pmc/list"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.pmc.enabled"
                                                [attr.tabindex]="featureFlags.pmc.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >{{ 'process_monitoring_checks' | translate }}</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                routerLink="/pmc/calendar"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.pmc.enabled"
                                                [attr.tabindex]="featureFlags.pmc.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >{{ 'process_monitoring_checks_calendar' | translate }}</a
                                            >
                                        </li>
                                        <li>
                                            <a
                                                routerLink="/pmc/spc"
                                                routerLinkActive="active"
                                                [attr.aria-disabled]="!featureFlags.pmc.enabled"
                                                [attr.tabindex]="featureFlags.pmc.enabled ? null : -1"
                                                (click)="toggleMobileMenu()"
                                                >SPC</a
                                            >
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            }
                            -->
                        </ul>
                    </li>

                    <h2 class="-mx-4 mb-1 flex items-center bg-white-light/30 px-7 py-3 font-extrabold uppercase dark:bg-dark dark:bg-opacity-[0.08]">Others</h2>

                    <li class="nav-item">
                        <ul>
                            @if (featureFlags.document.visible) {
                            <li class="nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.document.enabled }">
                                <a
                                    routerLink="/document/list"
                                    class="group"
                                    routerLinkActive="active"
                                    [attr.aria-disabled]="!featureFlags.document.enabled"
                                    [attr.tabindex]="featureFlags.document.enabled ? null : -1"
                                    (click)="toggleMobileMenu()"
                                >
                                    <div class="flex items-center">
                                        <icon-folder class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                        >{{ 'document_management' | translate }}</span>
                                    </div>
                                </a>
                            </li>
                            }
                            @if (featureFlags.equipment.visible) {
                            <li class="nav-item" [ngClass]="{ 'opacity-50 pointer-events-none': !featureFlags.equipment.enabled }">
                                <a
                                    routerLink="/equipment/list"
                                    class="group"
                                    routerLinkActive="active"
                                    [attr.aria-disabled]="!featureFlags.equipment.enabled"
                                    [attr.tabindex]="featureFlags.equipment.enabled ? null : -1"
                                    (click)="toggleMobileMenu()"
                                >
                                    <div class="flex items-center">
                                        <icon-box class="shrink-0 group-hover:!text-primary" />
                                        <span class="text-black dark:text-[#506690] dark:group-hover:text-white-dark ltr:pl-3 rtl:pr-3"
                                            >{{ 'equipment_list' | translate }}</span>
                                    </div>
                                </a>
                            </li>
                            }
                        </ul>
                    </li>
                </ul>
            </ng-scrollbar>
        </div>
    </nav>
</div>
